function updateCartCount(count) {
  document.querySelectorAll(".cart-count").forEach((el) => (el.textContent = count));
}

/* ---------- Added-to-cart drawer ---------- */
(function () {
  var LOCALE = (document.documentElement.lang || "en").slice(0, 2).toLowerCase();
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var FREE_SHIPPING_CENTS = 3900;
  var T = LOCALE === "de" ? {
    added: "In den Warenkorb gelegt",
    viewCart: "Warenkorb ansehen",
    checkout: "Zur Kasse",
    away: "Nur noch {amount} bis zum Gratisversand!",
    unlocked: "Gratisversand freigeschaltet!",
    close: "Schließen",
    error: "Der Artikel konnte nicht hinzugefügt werden."
  } : {
    added: "Added to cart",
    viewCart: "View cart",
    checkout: "Checkout",
    away: "Only {amount} away from free shipping!",
    unlocked: "You've unlocked free shipping!",
    close: "Close",
    error: "The item could not be added."
  };

  function money(cents) {
    return "€" + (cents / 100).toFixed(2).replace(".", ",");
  }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function ensureDrawer() {
    if (document.getElementById("nobi-drawer")) return;
    var html =
      '<div class="nobi-drawer-overlay" id="nobi-drawer-overlay"></div>' +
      '<aside class="nobi-drawer" id="nobi-drawer" role="dialog" aria-modal="true" aria-labelledby="nobi-drawer-title" tabindex="-1">' +
      '  <div class="nobi-drawer-head">' +
      '    <h2 id="nobi-drawer-title">' + esc(T.added) + "</h2>" +
      '    <button type="button" class="nobi-drawer-close" id="nobi-drawer-close" aria-label="' + esc(T.close) + '">&times;</button>' +
      "  </div>" +
      '  <div class="nobi-drawer-item" id="nobi-drawer-item"></div>' +
      "  <div>" +
      '    <a class="nobi-drawer-btn" id="nobi-drawer-viewcart" href="' + esc(ROOT + "cart") + '">' + esc(T.viewCart) + "</a>" +
      '    <a class="nobi-drawer-btn solid" href="' + esc(ROOT + "checkout") + '">' + esc(T.checkout) + "</a>" +
      "  </div>" +
      '  <div class="nobi-drawer-ship">' +
      '    <div id="nobi-drawer-ship-text"></div>' +
      '    <div class="nobi-drawer-bar"><span id="nobi-drawer-bar-fill"></span></div>' +
      "  </div>" +
      "</aside>";
    document.body.insertAdjacentHTML("beforeend", html);
    document.getElementById("nobi-drawer-close").addEventListener("click", closeDrawer);
    document.getElementById("nobi-drawer-overlay").addEventListener("click", closeDrawer);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeDrawer();
    });
  }

  function closeDrawer() {
    document.body.classList.remove("nobi-drawer-open");
  }

  function openDrawer(item, cart) {
    ensureDrawer();
    var imgUrl = item.image ? item.image + (item.image.indexOf("?") >= 0 ? "&" : "?") + "width=300" : "";
    var img = imgUrl
      ? '<img src="' + esc(imgUrl) + '" alt="' + esc(item.product_title) + '" width="130" height="130">'
      : "<span>" + esc((item.product_title || "?").charAt(0)) + "</span>";
    var lineCents = typeof item.final_price === "number" ? item.final_price : item.price;
    var qtyNote = item.quantity > 1 ? " &times; " + item.quantity : "";
    document.getElementById("nobi-drawer-item").innerHTML =
      '<div class="nobi-drawer-img">' + img + "</div>" +
      "<div>" +
      '  <div class="nobi-drawer-title">' + esc(item.product_title) + "</div>" +
      '  <div class="nobi-drawer-price">' + money(lineCents) + qtyNote + "</div>" +
      "</div>";
    document.getElementById("nobi-drawer-viewcart").textContent = T.viewCart + " (" + cart.item_count + ")";
    var total = cart.total_price || 0;
    var remaining = FREE_SHIPPING_CENTS - total;
    var shipEl = document.getElementById("nobi-drawer-ship-text");
    if (remaining > 0) {
      shipEl.innerHTML = esc(T.away).replace("{amount}", "<strong>" + money(remaining) + "</strong>");
    } else {
      shipEl.innerHTML = "<strong>" + esc(T.unlocked) + "</strong>";
    }
    var pct = Math.max(0, Math.min(100, Math.round((total / FREE_SHIPPING_CENTS) * 100)));
    var fill = document.getElementById("nobi-drawer-bar-fill");
    fill.style.width = "0%";
    document.body.classList.add("nobi-drawer-open");
    setTimeout(function () { fill.style.width = pct + "%"; }, 30);
    document.getElementById("nobi-drawer").focus({ preventScroll: true });
  }

  function afterAdd(item) {
    if (!item || item.status) throw item;
    return fetch("/cart.js")
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        openDrawer(item, cart);
        return cart;
      });
  }

  function addByVariant(variantId, quantity) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
      .then(function (res) { return res.json(); })
      .then(afterAdd);
  }

  function addByForm(form) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Accept": "application/json" },
      body: new FormData(form)
    })
      .then(function (res) { return res.json(); })
      .then(afterAdd);
  }

  window.nobiCart = { add: addByVariant, addForm: addByForm, open: openDrawer, close: closeDrawer };

  // Quick add on product cards
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-quick-add-variant]");
    if (!btn) return;
    e.preventDefault();
    var original = btn.textContent;
    btn.disabled = true;
    addByVariant(btn.dataset.quickAddVariant, 1)
      .catch(function (err) {
        alert((err && err.description) || T.error);
      })
      .then(function () {
        btn.disabled = false;
        btn.textContent = original;
      });
  });

  // Product page form
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute("action") || "";
    if (!/\/cart\/add(\b|$)/.test(action)) return;
    e.preventDefault();
    var submit = form.querySelector('[type="submit"]');
    if (submit) submit.disabled = true;
    addByForm(form)
      .catch(function (err) {
        alert((err && err.description) || T.error);
      })
      .then(function () {
        if (submit) submit.disabled = false;
      });
  });
})();

document.addEventListener("click", (e) => {
  if (e.target.matches("[data-qty-plus]")) {
    const input = e.target.parentElement.querySelector("[data-qty-input]");
    input.value = parseInt(input.value || "1", 10) + 1;
  }
  if (e.target.matches("[data-qty-minus]")) {
    const input = e.target.parentElement.querySelector("[data-qty-input]");
    input.value = Math.max(1, parseInt(input.value || "1", 10) - 1);
  }
});

document.addEventListener("click", (e) => {
  const thumbBtn = e.target.closest(".detail-thumb-btn");
  if (!thumbBtn) return;
  document.querySelectorAll(".detail-thumb-btn").forEach((b) => b.classList.remove("active"));
  thumbBtn.classList.add("active");
  const mainImg = document.getElementById("detail-main-img");
  if (mainImg) mainImg.src = thumbBtn.dataset.full;
});
